<template>
    <div class="w-full p-4 border border-gray-200">
        <div class="w-full mt-2 border-b-2 border-gray-200">
            <VueSignaturePad
                id="signature"
                width="100%"
                height="150px"
                ref="signaturePad"
                :options="options"
            />
        </div>
        <div class="md:mt-10 mt-6 flex justify-between">
            <div class="md:w-1/4 w-1/2 p-4 pl-0">
                <button
                        class="
                        w-full h-16 tracking-wide text-gray-600 text-4xl
                        border-gray-500 rounded border
                        shadow-md hover:outline-none focus:outline-none active:outline-none
                        py-2 px-6 inline-flex items-center"
                        @click="undo"
                >
                <span class="mx-auto text-base">
                    Löschen
                </span>
                </button>
            </div>

            <div class="md:w-1/4 w-1/2 p-4 pr-0">
                <button
                        class="
                        w-full h-16 tracking-wide text-gray-600 text-4xl
                        border-gray-500 rounded border
                        shadow-md hover:outline-none focus:outline-none active:outline-none
                        py-2 px-4 inline-flex items-center"
                        @click="save"
                >
                <span class="mx-auto text-base">
                    Speichern
                </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import VueSignaturePad from 'vue-signature-pad';

    export default {
        components: {
            VueSignaturePad
        },

        props: ['content', 'action'],

        data() {
            return {
                newCatalog: this.content,
                options: {
                    penColor: "#666"
                }
            }
        },

        methods: {
            undo() {
                this.$refs.signaturePad.undoSignature();
            },
            save() {
                const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

                if (! isEmpty) {
                    axios.post('/sign/'+this.newCatalog.uuid+'/'+this.action, {sign: data})
                        .then((response)=>{
                            window.location.href = '/'+this.action+'/success/'+this.newCatalog.uuid;
                        }).catch((error)=>{
                        console.log(error.response.data)
                    });
                }
            }
        }
    }
</script>
